/**
 * Electron IPC プラットフォームアダプタ (ElectronBridgeAdapter)
 * PCアプリ版（Electron）におけるメインプロセスとのIPC通信アダプタ
 */

import type { DisplayWorkArea, IPlatformBridgeAdapter, WindowBounds } from './IPlatformBridgeAdapter';

export interface ElectronAmbientAPI {
  isSupported?: () => boolean;
  setAlwaysOnTop: (enable: boolean) => Promise<void>;
  setClickThrough: (enable: boolean) => Promise<void>;
  getBounds: () => Promise<WindowBounds>;
  setBounds: (bounds: Partial<WindowBounds>) => Promise<void>;
  getWorkArea: () => Promise<DisplayWorkArea>;
}

declare global {
  interface Window {
    electronAmbientAPI?: ElectronAmbientAPI;
  }
}

export class ElectronBridgeAdapter implements IPlatformBridgeAdapter {
  private readonly api?: ElectronAmbientAPI;

  constructor(customApi?: ElectronAmbientAPI) {
    if (customApi) {
      this.api = customApi;
    } else if (typeof window !== 'undefined' && window.electronAmbientAPI) {
      this.api = window.electronAmbientAPI;
    }
  }

  public isSupported(): boolean {
    return Boolean(this.api);
  }

  public async setAlwaysOnTop(enable: boolean): Promise<void> {
    if (this.api?.setAlwaysOnTop) {
      await this.api.setAlwaysOnTop(enable);
    }
  }

  public async setClickThrough(enable: boolean): Promise<void> {
    if (this.api?.setClickThrough) {
      await this.api.setClickThrough(enable);
    }
  }

  public async getBounds(): Promise<WindowBounds> {
    if (this.api?.getBounds) {
      return await this.api.getBounds();
    }
    return { x: 0, y: 0, width: 320, height: 320 };
  }

  public async setBounds(bounds: Partial<WindowBounds>): Promise<void> {
    if (this.api?.setBounds) {
      await this.api.setBounds(bounds);
    }
  }

  public async getWorkArea(): Promise<DisplayWorkArea> {
    if (this.api?.getWorkArea) {
      return await this.api.getWorkArea();
    }
    return { x: 0, y: 0, width: 1920, height: 1080 };
  }
}
